// extracted by mini-css-extract-plugin
export var Layout = "Layout-module--Layout--a05c9";